import type {JSX, ReactElement} from 'react'
import {useState, useEffect} from 'react'
import Slider from 'react-slick'
import {clsx} from 'clsx'
import './slick-slider.module.css'
import styles from './quote-slider.module.css'

interface QuoteSliderProps {
	className?: string
	isLargeMode: boolean
	children: ReactElement[] | null
	autoPlay: boolean
	autoPlaySpeed?: number
}

export const QuoteSlider = ({
	className = '',
	isLargeMode = false,
	children = null,
	autoPlay = false,
	autoPlaySpeed = 1000,
}: QuoteSliderProps): JSX.Element => {
	const [isFocused, setIsFocused] = useState<boolean>(autoPlay)

	const settings = {
		dots: true,
		infinite: true,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,
		adaptiveHeight: true,
		dotsClass: `slick-dots`,
		autoplay: isFocused,
		autoplaySpeed: autoPlaySpeed,
	}

	useEffect(() => {
		const handleTabkey = (event: KeyboardEvent): void => {
			if (event.key === 'Tab' && isFocused) {
				setIsFocused(false)
			}
		}
		window.addEventListener('keydown', handleTabkey)
		return () => {
			window.removeEventListener('keydown', handleTabkey)
		}
	}, [isFocused])

	const largeMode = styles.largeMode || ''

	return (
		<Slider
			className={clsx(className, styles.quoteSlider, {
				[largeMode]: isLargeMode,
			})}
			{...settings}
		>
			{children}
		</Slider>
	)
}
